import { Helmet } from 'react-helmet-async';

export const ArticleSchema = ({
  title,
  description,
  author = 'RetailInvest Team',
  publishedDate,
  modifiedDate,
  imageUrl,
  url
}) => {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    image: imageUrl || 'https://images.pexels.com/photos/35437605/pexels-photo-35437605.jpeg',
    author: {
      '@type': 'Organization',
      name: author,
      url: 'https://www.retail-invest.com'
    },
    publisher: {
      '@type': 'Organization',
      name: 'RetailInvest by Heinrichs Immobilien',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.retail-invest.com/logo.png'
      }
    },
    datePublished: publishedDate,
    dateModified: modifiedDate || publishedDate,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    articleSection: 'Handelsimmobilien',
    inLanguage: 'de-DE'
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default ArticleSchema;
